import { StepCard, StepView } from '../../components/view';
import { StepPreview } from '../../components/preview/index';

export const LiConnection = ({
  isOpen = false,
  step = {},
  onOpen = () => {},
  onClose = () => {},
  blueprint = {},
}) => {
  if (isOpen) {
    return <StepPreview step={step} onClose={onClose} blueprint={blueprint} />;
  }
  return <StepView blueprint={blueprint} step={step} onOpen={onOpen} />;
};

export const LiConnectionView = (props) => {
  return (
    <StepCard {...props}>
      <LiConnection {...props} />
    </StepCard>
  );
};
